import React from 'react';
import './ModifyEmailPage.scss';
import Hero from "../../common/Hero/Hero";
import {useTranslation} from "react-i18next";
import ModifyEmail from "../../forms/ModifyEmail/ModifyEmail";

const ModifyEmailPage = () => {
  const {t} = useTranslation();
  return (
    <div className="ModifyEmailPage" data-testid="ModifyEmailPage">
      <Hero
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("operator.modify_email.page.title")}
        description={
          <div>
            {t("operator.modify_email.page.description")}
            <br />
          </div>
        }
      />
      <ModifyEmail />
    </div>
  );
};

ModifyEmailPage.propTypes = {};

export default ModifyEmailPage;
